import { render, staticRenderFns } from "./ShipmentAdd.vue?vue&type=template&id=0e8c9017&scoped=true"
import script from "./ShipmentAdd.vue?vue&type=script&lang=js"
export * from "./ShipmentAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8c9017",
  null
  
)

export default component.exports